import debounce from "debounce";

export function mainSection() {
    let mainSection = $(".main-section");

    mainSection.on("click", ".scroll-down", function (e) {
        e.preventDefault();

        $("body, html").animate({
            scrollTop: parseInt(mainSection.outerHeight())
        }, 500);
    });

    $(".main-section-slider")
        .on("destroy", function (ev, slick) {

            let
                carousel = $(this),
                reinit = debounce(function () {

                    // slick.activeBreakpoint will tell us the breakpoint at which the carousel was destroyed.
                    if (slick.activeBreakpoint < window.innerWidth) {
                        return;
                    }

                    // Re-initialize with the old settings.
                    carousel.slick(slick.options);

                    // Remove this event listener.
                    window.removeEventListener("resize", reinit);

                }, 500);

            // Assign our debounced callback to window.resize.
            window.addEventListener("resize", reinit);

        })
        .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            fade: true,
            arrows: false,
            dots: true,
            adaptiveHeight: true,
            mobileFirst: true,
            autoplay: false,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: "unslick"
                }
            ]
        });

}


// WEBPACK FOOTER //
// ./assets/js/modules/mainSection.js